import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as urlTemplate from 'url-template';

import { searchBarApi } from '@search-bar/search-bar.api';
import { AutocompletePlaces } from '@search-bar/entities/autocomplete-places';
import { FindBillingCities, BillingCitiesResponse } from '@billing/entities/billing.payload';
import { environment as ENV } from '@environment';
import {
  AutoCompleteDestination, DestinationPlaceInfoPayload, DestinationPlaceInfoResponse, HotelDestinationInputType
} from '@shared/base-search-bar/entities/autocomplete-destionation';
import {
  AutoCompleteTravelExtra, TravelExtraActivityInfoPayload, TravelExtraActivityInfoResponse
} from '@shared/base-search-bar/entities/autocomplete-travel-extra';

@Injectable()
export class AutocompletePlacesService {

  constructor(private http: HttpClient) { }

  public searchPlaces(query: string): Observable<AutocompletePlaces> {
    const url = ENV.is_enable_travel_city_autoComplete ? searchBarApi.travel_city_search.url : searchBarApi.search.url;
    return this.http.get<AutocompletePlaces>(urlTemplate.parse(url).expand({
      term: query
    }));

  }

  public searchDestinationPlaces(query: string): Observable<AutoCompleteDestination> {
    return this.http.get<AutoCompleteDestination>(urlTemplate.parse(searchBarApi.hotel_search_destination.url).expand({
      searchText: query,
      locale: ENV.language.toLowerCase()
    }));
  }

  public searchExtraByQuery(query: string): Observable<AutoCompleteTravelExtra> {
    return this.http.get<AutoCompleteTravelExtra>(urlTemplate.parse(searchBarApi.travel_extra_search.url).expand({
      term: query,
      locale: ENV.language.toLowerCase()
    }));
  }

  public searchTravelExtraActivityInfo(payload: TravelExtraActivityInfoPayload): Observable<TravelExtraActivityInfoResponse> {
    return this.http.get<TravelExtraActivityInfoResponse>(urlTemplate.parse(searchBarApi.travel_extra_input_activity_info.url)
      .expand({ id: payload.Code }));
  }

  public searchPlacesByCountryCode(payload: FindBillingCities): Observable<BillingCitiesResponse> {
    return this.http.get<BillingCitiesResponse>(urlTemplate.parse(searchBarApi.find_code.url).expand({
      code: payload.code, type: payload.type
    }));
  }

  public searchDestinationPlaceInfo(payload: DestinationPlaceInfoPayload): Observable<DestinationPlaceInfoResponse> {
    return this.http.get<DestinationPlaceInfoResponse>(
      urlTemplate.parse(searchBarApi.hotel_search_destination_by_info.url).expand({
        id: payload?.id,
        isHotel: payload?.type === HotelDestinationInputType.hotel,
        locale: ENV.language.toLowerCase()
      }));
  }

}
